import { Grid } from '@chakra-ui/react';
import { useUserContext } from 'context/UserContextProvider';
import { get } from 'lodash';
import { useTranslation } from 'react-i18next';

import useStatsQuery from '../../../hooks/useStatsQuery';
import OpenTasksCard from './OpenTasksCard';

export enum PagePathMapping {
  service_entry = 'service-record',
  service_entry_qa = 'service-record',
  account_registration = 'account',
  service_entry_deletion = 'service-record',
  verification_step_1 = 'workshop-verification-request',
  verification_step_2 = 'workshop-verification-request',
  service_history_request = 'service-history-request',
  workshop_data_update = 'workshop-update-request',
  account_deletion = 'account',
  b2c_verification = 'b2c-verification-request',
  b2c_service_history_request = 'b2c-service-history-request',
}
const OpenTasksCardsOverview = () => {
  const { t } = useTranslation();
  const statsQuery = useStatsQuery();
  const { isMember } = useUserContext();
  const userHasQmPermission = isMember('service-entries:qm');

  return (
    <Grid templateColumns={'repeat(auto-fit, minMax(20rem, 1fr))'} gap={4}>
      <OpenTasksCard
        label={t(`workshop_verification_request:verification_step_1.label`)}
        type={'verification_step_1'}
        value={get(statsQuery.data, 'verification_step_1.total', '') as any}
        pagePathMapping={PagePathMapping}
        fastlane={get(statsQuery.data, 'verification_step_1.fastlane', '') as any}
        isLoading={statsQuery.isFetching || statsQuery.isLoading}
        isAllowed={isMember('tasks:assign-next')}
      />
      <OpenTasksCard
        label={t(`workshop_verification_request:verification_step_2.label`)}
        type={'verification_step_2'}
        value={get(statsQuery.data, 'verification_step_2.total', '') as any}
        pagePathMapping={PagePathMapping}
        fastlane={get(statsQuery.data, 'verification_step_2.fastlane', '') as any}
        isLoading={statsQuery.isFetching || statsQuery.isLoading}
        isAllowed={isMember('tasks:assign-next')}
      />

      <OpenTasksCard
        label={t(`workshop:account_registration.label`)}
        type={'account_registration'}
        pagePathMapping={PagePathMapping}
        value={get(statsQuery.data, 'account_registration.total', '') as any}
        fastlane={get(statsQuery.data, 'account_registration.fastlane', '') as any}
        isLoading={statsQuery.isFetching || statsQuery.isLoading}
        isAllowed={isMember('tasks:assign-next')}
      />
      <OpenTasksCard
        label={t(`service_history_request:label`)}
        type={'service_history_request'}
        value={get(statsQuery.data, 'service_history_request.total', '') as any}
        pagePathMapping={PagePathMapping}
        fastlane={get(statsQuery.data, 'service_history_request.fastlane', '') as any}
        isLoading={statsQuery.isFetching || statsQuery.isLoading}
        isAllowed={isMember('tasks:assign-next')}
      />
      <OpenTasksCard
        label={t(`b2c_verification:header`)}
        type={'b2c_verification'}
        pagePathMapping={PagePathMapping}
        value={get(statsQuery.data, 'b2c_verification.total', '') as any}
        fastlane={get(statsQuery.data, 'b2c_verification.fastlane', '') as any}
        isLoading={statsQuery.isFetching || statsQuery.isLoading}
        isAllowed={isMember('tasks:assign-next')}
      />
      <OpenTasksCard
        label={t(`b2c_service_history_request:service_history.label`)}
        type={'b2c_service_history_request'}
        pagePathMapping={PagePathMapping}
        value={get(statsQuery.data, 'b2c_service_history_request.total', '') as any}
        fastlane={get(statsQuery.data, 'b2c_service_history_request.fastlane', '') as any}
        isLoading={statsQuery.isFetching || statsQuery.isLoading}
        isAllowed={isMember('tasks:assign-next')}
      />

      <OpenTasksCard
        label={t(`service_record:label`)}
        type={'service_entry'}
        pagePathMapping={PagePathMapping}
        value={get(statsQuery.data, 'service_entry.total', '') as any}
        fastlane={get(statsQuery.data, 'service_entry.fastlane', '') as any}
        isLoading={statsQuery.isFetching || statsQuery.isLoading}
        isAllowed={isMember('tasks:assign-next')}
      />
      {userHasQmPermission && (
        <OpenTasksCard
          label={t(`service_record:service_entry_qa.label`)}
          type={'service_entry_qa'}
          pagePathMapping={PagePathMapping}
          value={get(statsQuery.data, 'service_entry_qa.total', '') as any}
          fastlane={get(statsQuery.data, 'service_entry_qa.fastlane', '') as any}
          isLoading={statsQuery.isFetching || statsQuery.isLoading}
          isAllowed={isMember('tasks:assign-next')}
        />
      )}

      <OpenTasksCard
        label={t(`pages:dashboard.request_deletion.label`)}
        value={get(statsQuery.data, 'service_entry_deletion.total', '') as any}
        pagePathMapping={PagePathMapping}
        fastlane={get(statsQuery.data, 'service_entry_deletion.fastlane', '') as any}
        type={'service_entry_deletion'}
        isLoading={statsQuery.isFetching || statsQuery.isLoading}
        isAllowed={isMember('tasks:assign-next')}
      />

      <OpenTasksCard
        label={t(`workshop_update_request:label`)}
        type={'workshop_data_update'}
        value={get(statsQuery.data, 'workshop_data_update.total', '') as any}
        pagePathMapping={PagePathMapping}
        fastlane={get(statsQuery.data, 'workshop_data_update.fastlane', '') as any}
        isLoading={statsQuery.isFetching || statsQuery.isLoading}
        isAllowed={isMember('tasks:assign-next')}
      />
      <OpenTasksCard
        label="Account deletion"
        type={'account_deletion'}
        value={get(statsQuery.data, 'account_deletion.total', '') as any}
        pagePathMapping={PagePathMapping}
        fastlane={get(statsQuery.data, 'account_deletion.fastlane', '') as any}
        isLoading={statsQuery.isFetching || statsQuery.isLoading}
        isAllowed={isMember('tasks:assign-next')}
      />
    </Grid>
  );
};

export default OpenTasksCardsOverview;
